import React from 'react'
import WheatItem from 'assets/svg/WheatItem'
import TruckQuota from 'assets/svg/TruckQuota'
import { blue, green, red, yellow } from '@qirapagos/lib/theme/colors'
import { ActivityMovement } from 'store/activity/types'
import TransferRejected from '@qirapagos/lib/assets/svg/TransferRejected'
import TransferReceive from '@qirapagos/lib/assets/svg/TransferReceive'
import TransferSend from '@qirapagos/lib/assets/svg/TransferSend'

export enum TypeMovementsActivity {
  MOVEMENT_TRANSFER_DEBIT = 'MOVEMENT_TRANSFER_DEBIT',
  MOVEMENT_TRANSFER_CREDIT = 'MOVEMENT_TRANSFER_CREDIT',
  SALE_ORDER_REJECTED = 'SALE_ORDER_REJECTED',
  SALE_ODER_COUNTER_OFFER = 'SALE_ODER_COUNTER_OFFER',
  SALE_ORDER_PENDING = 'SALE_ORDER_PENDING',
  SALE_ORDER_MIGRATED = 'SALE_ORDER_MIGRATED',
  SALE_ORDER_REMOVED = 'SALE_ORDER_REMOVED',
  QUOTA_AWARDED = 'QUOTA_AWARDED',
  QUOTA_REJECTED = 'QUOTA_REJECTED',
  QUOTA_CANCELED = 'QUOTA_CANCELED',
  QUOTA_REQUIRED = 'QUOTA_REQUIRED',
  APPLICATIONS = 'APPLICATIONS',
  LIQUIDATION = 'LIQUIDATION',
  PERFORMANCE = 'PERFORMANCE',
  DEBIT_TRANSFER_FAILED = 'DEBIT_TRANSFER_FAILED',
  DEBIT_REVERSED = 'DEBIT_REVERSED',
  CREDIT_REVERSED = 'CREDIT_REVERSED',
  ADJUSTMENT_BALANCE_CREDIT = 'ADJUSTMENT_BALANCE_CREDIT',
  ADJUSTMENT_BALANCE_DEBIT = 'ADJUSTMENT_BALANCE_DEBIT'
}

export const getInfo = (activity: ActivityMovement) => {
  switch (activity.movementType) {
    case TypeMovementsActivity.MOVEMENT_TRANSFER_DEBIT:
      return {
        title: 'Enviaste',
        icon: <TransferSend />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.MOVEMENT_TRANSFER_CREDIT:
      return {
        title: 'Recibiste',
        icon: <TransferReceive />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.DEBIT_TRANSFER_FAILED:
      return {
        title: 'Enviaste',
        icon: <TransferRejected />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.SALE_ORDER_REJECTED:
      return {
        title: 'Contrato rechazado',
        icon: <WheatItem color={red} />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.SALE_ORDER_REMOVED:
      return {
        title: 'Contrato eliminado',
        icon: <WheatItem color={red} />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.SALE_ODER_COUNTER_OFFER:
      return {
        title: 'Contra oferta recibida',
        icon: <WheatItem color={blue} />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.SALE_ORDER_MIGRATED:
      return {
        title: 'Contrato aprobado',
        icon: <WheatItem color={green} />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.SALE_ORDER_PENDING:
      return {
        title: 'Orden de venta solicitada',
        icon: <WheatItem color={yellow} />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.QUOTA_AWARDED:
      return {
        title: 'Cupo otorgado',
        icon: <TruckQuota shownAtActivity color={green} />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.QUOTA_REJECTED:
      return {
        title: 'Cupo rechazado',
        icon: <TruckQuota color={red} shownAtActivity />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.QUOTA_CANCELED:
      return {
        title: 'Cupo anulado',
        icon: <TruckQuota color={red} shownAtActivity />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.QUOTA_REQUIRED:
      return {
        title: 'Cupo solicitado',
        icon: <TruckQuota shownAtActivity color={yellow} />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.PERFORMANCE:
      return {
        title: 'Crédito rendimiento',
        icon: <TransferReceive />,
        amount: activity.amount,
        owner: activity.owner,
        date: activity.date
      }
    case TypeMovementsActivity.DEBIT_REVERSED:
      return {
        title: 'Débito reversado',
        icon: <TransferSend />,
        amount: activity.amount,
        owner: `${activity.owner}`,
        date: activity.date
      }
    case TypeMovementsActivity.CREDIT_REVERSED:
      return {
        title: 'Crédito reversado',
        icon: <TransferReceive />,
        amount: activity.amount,
        owner: `${activity.owner}`,
        date: activity.date
      }
    case TypeMovementsActivity.ADJUSTMENT_BALANCE_DEBIT:
      return {
        title: 'Ajuste Administrativo',
        icon: <TransferSend />,
        amount: activity.amount,
        owner: `${activity.owner}`,
        date: activity.date
      }
    case TypeMovementsActivity.ADJUSTMENT_BALANCE_CREDIT:
      return {
        title: 'Ajuste Administrativo',
        icon: <TransferReceive />,
        amount: activity.amount,
        owner: `${activity.owner}`,
        date: activity.date
      }
    // TODO RRQP-2444 add applications and liquidations
    default:
      return {
        title: '',
        icon: null,
        amount: '',
        owner: ''
      }
  }
}
